var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32146 0.857147H5.67859V1.28573H6.32146V0.857147Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.85715C5.58649 9.85715 5.25 10.1936 5.25 10.6071C5.25 11.0207 5.58649 11.3571 6 11.3571C6.41351 11.3571 6.75 11.0207 6.75 10.6071C6.75 10.1936 6.41351 9.85715 6 9.85715ZM6 10.9286C5.82274 10.9286 5.67858 10.7844 5.67858 10.6072C5.67858 10.4299 5.82277 10.2857 6 10.2857C6.17723 10.2857 6.32142 10.4299 6.32142 10.6072C6.32142 10.7844 6.17726 10.9286 6 10.9286Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53442 0H2.46549C1.87411 0 1.39282 0.479953 1.39282 1.06985V10.9301C1.39282 11.52 1.87413 12 2.46551 12H9.53442C10.1258 12 10.6071 11.52 10.6071 10.9301V1.06985C10.6071 0.479953 10.1258 0 9.53442 0ZM10.1785 10.9301C10.1785 11.2838 9.88955 11.5714 9.53442 11.5714H2.46549C2.11036 11.5714 1.82138 11.2838 1.82138 10.9301V1.06985C1.82138 0.716203 2.11036 0.428555 2.46549 0.428555H9.5344C9.88953 0.428555 10.1785 0.71618 10.1785 1.06985L10.1785 10.9301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/Tablet.e41f58250bd686911ccebe276d41c1a6.svg";
export { ForwardRef as ReactComponent };